let OptionsPower = [
    { "label":"1", "value":"1" },
    { "label":"3", "value":"3" },
    { "label":"5", "value":"5" }
]
export default OptionsPower;